import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import {MessageService} from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { cMembership } from 'src/types/memberships';
import { membership_returndata } from 'src/types/membership_returndata';
import { admission_returndata } from 'src/types/admission_returndata';
import { v4 as uuidv4  } from 'uuid';
import { cMembershipadmission } from 'src/types/membershipadmissions';
import { emailtemplate_returndata } from 'src/types/emailtemplate_returndata';
import { package_returndata } from 'src/types/package_returndata';
import { cPackage } from 'src/types/package';

@Component({
  selector: 'app-membershiptypeedit',
  templateUrl: './membershiptypeedit.component.html',
  styleUrls: ['./membershiptypeedit.component.css']
})
export class MembershiptypeeditComponent  implements OnInit {

  VenueID: string = localStorage.getItem("SmartVenueID")!;
  Membership: cMembership;
  httpResponse: any;
  id: string;
  pageReady: boolean = true;

  membershipNameValid: boolean = true;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  stateOptionsPeriod: any[] = [];
  stateOptionsPackageScope: any[] = [];

  stateOptions: any[] = [];
  stateOptionsVenueOnly: any[] = [];

  availableAdmissions: any = [];

  Identifier: string = uuidv4();
  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;
  EmailTemplates: any = [];

  TimePeriods: any = [];

  ListPackages:any;

  packagesValid: boolean = true;
  admissionsValid: boolean = true;
  membershipDescValid: boolean = true;

  FileChosen: string = "";
  HTMLbmxurl: string = bmxurl;

  emailTemplateValid: boolean = true;

  newStartDate: Date = new Date();
  newEndDate: Date = new Date() ;

  membershipDateValid: boolean = true;
  BookingQuestionnaires: any[] = [];

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private messageService: MessageService, private globalService: GlobalService) { 
    
    this.loadQuestionnaires();
    
    this.Membership = {
      id: null,
      membershiptypeid: null,
      name: "",
      description: "",
      imageurl: "",
      durationtype: "FIXED",
      duration: 0,
      startdate: new Date().toISOString(),
      enddate: new Date().toISOString(),
      membershipadmissions: [],
      pPackages: [],
      packages: [],
      packagescope: "ALL",
      emailtemplate: null,
      discount: null,
      venueid: this.VenueID,
      membershipemail: true,
      disabled: false,
      limituses: false,
      maxuses: 1,
      maxusesperiod: "WEEKLY",
      setmaxnumberofthismembership: false,
      maxnumberofthismembership: 0,
      membershiptype: "MEMBERSHIP",
      customer: null,
      venueonly: false
    }

    this.TimePeriods = [
      {name: 'Daily', value: 'DAILY'}, 
      {name: 'Weekly', value: 'WEEKLY'}, 
      {name: 'Monthly', value: 'MONTHLY'}, 
      {name: 'Yearly', value: 'YEARLY'}
    ];

    // this.stateOptionsPeriod = [
    //   {label: 'Fixed Period', value: 'FIXED'}, 
    //   {label: 'Duration', value: 'DURATION'},
    //   {label: 'Recurring', value: 'RECURRING'}  
    // ];

    this.stateOptionsPeriod = [
      {label: 'Fixed Period', value: 'FIXED'}, 
      {label: 'Duration', value: 'DURATION'}
    ];

    this.stateOptionsPackageScope = [
      {label: 'All Packages', value: 'ALL'}, 
      {label: 'Selected Packages', value: 'SELECTED'}
    ];

    this.stateOptions = [
      {label: 'Yes', value: true},
      {label: 'No', value: false}
    ];

    this.stateOptionsVenueOnly = [
      {label: 'Venue Only', value: true},
      {label: 'Venue and Public', value: false}
    ];

    this.loadAdmissions(false);

    this.http.get(bmxurl + "/EmailTemplateList/" + this.VenueID + "/false").subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.EmailTemplates = (response as emailtemplate_returndata).data;
      }
      else
      {
        this.messageService.add({severity:'warn', summary:'Response Message', detail: this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Email Templates, error: ' + error.messages});
    });
  }

  uploadedFile(event){
    this.Membership.imageurl = event.originalEvent.body.data;
    let newNonce = uuidv4();

    this.FileChosen = event.originalEvent.body.data + "?n=" + newNonce;
  }

  removeImage(){
      this.FileChosen = null;
      this.Membership.imageurl = null;
  }

  onErrorFileUpload(event){
    this.messageService.add({ severity: 'error', summary: 'Image not uploaded', detail: 'Could not upload image: ' + event.error });
  }

  add_years(dt,n) 
  {
  return new Date(dt.setFullYear(dt.getFullYear() + n));      
  }
     
  AddToList(product){
    if(this.Membership.pPackages == null)
    {
      let newId = uuidv4();
      let newpeId = uuidv4();

      this.Membership.pPackages = [];
      let newPackage: cPackage = {
        id: product.id,
        packageId: product.packageId,
        name: product.name,
        eventid: product.eventid,
        description: product.description,
        imageurl: product.imageurl,
        message: product.message,
        disabled: product.disabled,
        venueID: this.VenueID,
        resources: product.resources,
        startTimes: product.startTimes,
        admissions: product.admissions,
        packageLength: product.packageLength,
        questionnaire: product.questionnaire,
        visibility: product.visibility,
        min:product.min,
        max:product.max,
        tags: product.tags,
        startDate: product.startDate,
        endDate: product.endDate,
        colour: product.colour,
        packageRule: product.packageRule,
        packageRestriction: product.packageRestriction,
        extras: product.extras,
        publicDepositPolicy: product.publicDepositPolicy,
        venueDepositPolicy: product.venueDepositPolicy,
        additionalresources: product.additionalresources,
        confirmation: product.confirmation,
        warning: product.warning,
        originatingid: product.originatingid,
        bookingscannotbemadewithinxminutes: product.bookingscannotbemadewithinxminutes,
        bookingscannotbemadeafterxminutes: product.bookingscannotbemadeafterxminutes,
        cannotmakebookingstoday: product.cannotmakebookingstoday,
        discounttype: product.discounttype,
        discountamount: product.discountamount,
        discountcode: product.discountcode,
        discountstart: product.discountstart,
        discountend: product.discountend,
        earlybirddiscount: product.earlybirddiscount,
        discountrangetype: product.discountrangetype,
        discountdaysbefore: product.discountdaysbefore,
        imageguid: product.imageguid,
        bookingtimeout: product.bookingtimeout,
        maxcalendarmonths: product.maxcalendarmonths,
        packageupgrades: product.packageupgrades,
        packageabupgrades: product.packageabupgrades,
        waiverrequired: product.waiverrequired,
        ispartypackage: product.ispartypackage,
        bookingfeeid: product.bookingfeeid,
        portaltemplateid: product.portaltemplateid,
        cannotbepaidwithvoucher: product.cannotbepaidwithvoucher
      }

      this.Membership.pPackages.push(newPackage);
    }
    else{
      let newId = uuidv4();
      let newpeId = uuidv4();

      let newPackage: cPackage = {
        id: product.id,
        packageId: product.packageId,
        name: product.name,
        eventid: product.eventid,
        description: product.description,
        imageurl: product.imageurl,
        message: product.message,
        disabled: product.disabled,
        venueID: this.VenueID,
        resources: product.resources,
        startTimes: product.startTimes,
        admissions: product.admissions,
        packageLength: product.packageLength,
        questionnaire: product.questionnaire,
        visibility: product.visibility,
        min:product.min,
        max:product.max,
        tags: product.tags,
        startDate: product.startDate,
        endDate: product.endDate,
        colour: product.colour,
        packageRule: product.packageRule,
        packageRestriction: product.packageRestriction,
        extras: product.extras,
        publicDepositPolicy: product.publicDepositPolicy,
        venueDepositPolicy: product.venueDepositPolicy,
        additionalresources: product.additionalresources,
        confirmation: product.confirmation,
        warning: product.warning,
        originatingid: product.originatingid,
        bookingscannotbemadewithinxminutes: product.bookingscannotbemadewithinxminutes,
        bookingscannotbemadeafterxminutes: product.bookingscannotbemadeafterxminutes,
        cannotmakebookingstoday: product.cannotmakebookingstoday,
        discounttype: product.discounttype,
        discountamount: product.discountamount,
        discountcode: product.discountcode,
        discountstart: product.discountstart,
        discountend: product.discountend,
        earlybirddiscount: product.earlybirddiscount,
        discountrangetype: product.discountrangetype,
        discountdaysbefore: product.discountdaysbefore,
        imageguid: product.imageguid,
        bookingtimeout: product.bookingtimeout,
        maxcalendarmonths: product.maxcalendarmonths,
        packageupgrades: product.packageupgrades,
        packageabupgrades: product.packageabupgrades,
        waiverrequired: product.waiverrequired,
        ispartypackage: product.ispartypackage,
        bookingfeeid: product.bookingfeeid,
        portaltemplateid: product.portaltemplateid,
        cannotbepaidwithvoucher: product.cannotbepaidwithvoucher
      }

      this.Membership.pPackages.push(newPackage);
    }

    this.ListPackages = this.ListPackages.filter(obj => obj.id !== product.id);
  }

  RemoveFromList(product){
    this.Membership.pPackages = this.Membership.pPackages.filter(obj => obj.id !== product.id);

    this.ListPackages.push(product);

    var sortedArray:any[] = this.ListPackages.sort((n1,n2) => {
      if (n1.name > n2.name) {
          return 1;
      }
  
      if (n1.name < n2.name) {
          return -1;
      }
    });

    this.ListPackages = sortedArray;
  }

  AddToAdmissions(admission){
    if(this.Membership.membershipadmissions == null)
      this.Membership.membershipadmissions = [];

    let newAdm: cMembershipadmission = {
      id: uuidv4(),
      index: 0,
      name: admission.name,
      membershipadmissionid: uuidv4(),
      min: 0,
      max: 0,
      price: 0,
      detailsrequired: false,
      admissionid: admission.admissionid,
      numberofadmissions: 0,
      participant: true,
      membershiptypeid: this.Membership.membershiptypeid,
      questionnaire: admission.questionnaire,
      inprogress: true,
      admissionsindex: admission.admissionsindex
    }

    this.Membership.membershipadmissions.push(newAdm);
    this.availableAdmissions = this.availableAdmissions.filter(obj => obj.admissionid !== admission.admissionid);
  }

  removeFromAdmissions(admission){
    this.Membership.membershipadmissions = this.Membership.membershipadmissions.filter(obj => obj.admissionid !== admission.admissionid);
  }

  loadAdmissions(showdisabled: boolean) {
    this.http.get(bmxurl + "AdmissionList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.availableAdmissions = (response as admission_returndata).data;
    }, error => {
    });
  }
  
  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");

    //Get packages
    this.http.get(bmxurl + "/packagelist/" + this.VenueID + "/false").subscribe(response => {
      if((response as package_returndata).succeeded == true)
      {
        this.ListPackages = (response as package_returndata).data;

        this.http.get(bmxurl + "User/" + userid).subscribe(response => {
          this.httpResponse =  (response as users_returndata)
          if(this.httpResponse.succeeded)
          {
            let user = this.httpResponse.data;
    
            if(getAccess("CLASSES", user)){
              this.AccessAllowed = true;
    
              this.id = this.route.snapshot.paramMap.get('id');
              if(this.id != "0")
              {
                this.pageReady = false;
                this.http.get(bmxurl + "membershiptype/" + this.VenueID + "/" + this.id).subscribe(response => {
                  this.httpResponse = (response as membership_returndata)
                  if (this.httpResponse.succeeded)
                  {
                    this.Membership = {
                      id: (this.httpResponse.data as cMembership).id,
                      membershiptypeid: (this.httpResponse.data as cMembership).membershiptypeid,
                      name: (this.httpResponse.data as cMembership).name,
                      description: (this.httpResponse.data as cMembership).description,
                      imageurl: (this.httpResponse.data as cMembership).imageurl,
                      duration: (this.httpResponse.data as cMembership).duration,
                      durationtype: (this.httpResponse.data as cMembership).durationtype,
                      startdate: (this.httpResponse.data as cMembership).startdate,
                      enddate: (this.httpResponse.data as cMembership).enddate,
                      membershipadmissions: (this.httpResponse.data as cMembership).membershipadmissions,
                      pPackages: [],
                      packages: (this.httpResponse.data as cMembership).packages,
                      packagescope: (this.httpResponse.data as cMembership).packagescope,
                      emailtemplate: (this.httpResponse.data as cMembership).emailtemplate,
                      membershipemail: (this.httpResponse.data as cMembership).membershipemail,
                      discount: (this.httpResponse.data as cMembership).discount,
                      venueid: (this.httpResponse.data as cMembership).venueid,
                      disabled: (this.httpResponse.data as cMembership).disabled,
                      limituses: (this.httpResponse.data as cMembership).limituses,
                      maxuses: (this.httpResponse.data as cMembership).maxuses,
                      maxusesperiod: (this.httpResponse.data as cMembership).maxusesperiod,
                      setmaxnumberofthismembership: (this.httpResponse.data as cMembership).setmaxnumberofthismembership,
                      maxnumberofthismembership: (this.httpResponse.data as cMembership).maxnumberofthismembership,
                      membershiptype: (this.httpResponse.data as cMembership).membershiptype,
                      customer: (this.httpResponse.data as cMembership).customer,
                      venueonly: (this.httpResponse.data as cMembership).venueonly ?? false
                    };

                    this.newStartDate = new Date(Number(this.Membership.startdate.substring(0,4)), Number(this.Membership.startdate.substring(5,7)) - 1, Number(this.Membership.startdate.substring(8,10)));
                    this.newEndDate = new Date(Number(this.Membership.enddate.substring(0,4)), Number(this.Membership.enddate.substring(5,7)) - 1, Number(this.Membership.enddate.substring(8,10)));

    
                    this.FileChosen = this.Membership.imageurl;

                    this.ListPackages.forEach(element => {
                      if(this.Membership.packages != null && this.Membership.packages != undefined && this.Membership.packages.length > 0)
                      {
                        if(this.Membership.packages.includes(element.packageId))
                        {
                          this.Membership.pPackages.push(element);
                        }
                      }
                    });

                    //remove package in pPackages from ListPackages
                    this.ListPackages = this.ListPackages.filter(obj => !this.Membership.pPackages.some(obj2 => obj2.id === obj.id));
    
                    this.pageReady = true;
                  }
                  else
                  {
                    this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting membership'});
                    this.pageReady = false;
                  }
                }, error => {
                  this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting membership, error:' + error.messages[0]});
                  this.pageReady = false;
                });
              }
              else
              {
                this.newStartDate = new Date();
                this.newEndDate = new Date();
                //Five years out. This is how long the type stays sellable for, which is nothing
                //to do with the duration - that is the length of a membership once bought.
                this.newEndDate.setFullYear(this.newEndDate.getFullYear() + 5);
              }
            }
    
            this.CompletedLoading = true;
    
          }
        }, error => {
          this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
        });

        if ((response as package_returndata).messages.length > 0)
        {
          (response as package_returndata).messages.forEach(error => {
            this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
          });
        }
      }
    }, error => {
    });


  }

  stringifyDate(Year: number, Month: number, Day: number): string
  {
    let returnString = "";

    returnString = Year + "-" +  ('00' + (Month + 1).toString()).slice(-2) + "-" +  ('00' + Day.toString()).slice(-2)+ "T00:00:00.0000Z";

    return returnString;
  }

  DoDateCheck()
  {
    let AllValid = true;

     let startdatestring = "";
    
    startdatestring = this.stringifyDate(new Date(this.newStartDate).getFullYear(), new Date(this.newStartDate).getMonth(), new Date(this.newStartDate).getDate());

    this.Membership.startdate = startdatestring;

     let enddatestring = "";

     enddatestring = this.stringifyDate(new Date(this.newEndDate).getFullYear(), new Date(this.newEndDate).getMonth(), new Date(this.newEndDate).getDate());

    this.Membership.enddate = enddatestring;

    if(this.Membership.startdate > this.Membership.enddate)
    {
      AllValid = false;
      this.membershipDateValid = false;
    }
    else
    {
      this.membershipDateValid = true;
    }

    return AllValid
  }

  updateData()
  {
    if(this.DoDateCheck())
    {
      let index = 0;
      this.Membership.membershipadmissions.forEach(adm => {
        adm.index = index;
        index++;
      });

      let AdmissionsValid = true;

      this.Membership.membershipadmissions.forEach(adm => {
        if(adm.min > adm.max || adm.max < 1)
        {
          AdmissionsValid = false;
        }
      });

      if(AdmissionsValid)
      {
        if(!this.Membership.limituses)
        {
          this.Membership.maxuses = 0;
          this.Membership.maxusesperiod = "";
        }

        if(!this.Membership.setmaxnumberofthismembership)
        {
          this.Membership.maxnumberofthismembership = 0;
        }

        if (this.DoValidCheck())
        {
          if(this.id == "0")
          {
            this.Membership.packages = [];

            this.Membership.pPackages.forEach(element => {
              this.Membership.packages.push(element.packageId);
            });
            this.Membership.pPackages = [];

            this.http.post<cMembership>(bmxurl + "/membershiptype", this.Membership).subscribe(response => {
              this.httpResponse = response
                if(this.httpResponse.succeeded)
                {
                  this.messageService.add({severity:'success', summary:'Saved', detail:'Membership successfully updated'});
                  this.router.navigateByUrl("/memberships");
                }
                }, error => {
                  this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
              })
          }
          else
          {
            this.Membership.disabled = false;

            this.Membership.packages = [];
            
            this.Membership.pPackages.forEach(element => {
              this.Membership.packages.push(element.packageId);
            });

            this.Membership.pPackages = [];
            
            this.http.put<cMembership>(bmxurl + "/membershiptype", this.Membership).subscribe(response => {
            this.httpResponse = response
              if(this.httpResponse.succeeded)
              {
                this.messageService.add({severity:'success', summary:'Saved', detail:'Membership successfully updated'});
                this.router.navigateByUrl("/memberships");
              }
              }, error => {
                this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
            })
          }
        }
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Not Saved', detail:'Check the Admissions on this Membership, maximun value should be greater than the miniumum value and the minimum value should gbe greater than zero'});
      }
    }
  }

  DoValidCheck()
  {
    let AllValid = true;

    if(this.Membership.emailtemplate == null || this.Membership.emailtemplate == undefined)
    {
      AllValid = false;
      this.emailTemplateValid = false;
    }
    else
    {
      this.emailTemplateValid = true;
    }

    if(this.Membership.name == null || this.Membership.name == "")
    {
      AllValid = false;
      this.membershipNameValid = false;
    }
    else
    {
      this.membershipNameValid = true;
    }

    if(this.Membership.description == null || this.Membership.description == "")
      {
        AllValid = false;
        this.membershipDescValid = false;
      }
      else
      {
        this.membershipDescValid = true;
      }

    if(this.Membership.packagescope != "ALL" && this.Membership.pPackages.length == 0)
      {
        AllValid = false;
        this.packagesValid = false;
      }
      else
      {
        this.packagesValid = true;
      }

      if(this.Membership.membershipadmissions.length == 0)
        {
          AllValid = false;
          this.admissionsValid = false;
      }
      else
      {
        this.admissionsValid = true;
      }


    return AllValid;
  }

  loadQuestionnaires(){
    this.http.get(bmxurl + "QuestionnaireList/" + this.VenueID).subscribe(response => {
      this.BookingQuestionnaires = (response as any).data;
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Questionnaires, error:' + error.messages[0]});
    });
  }

  returnToList()
  {
    this.router.navigateByUrl("/memberships");
  }
}
